import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content']
  connect() {
    const contentStyle = window.getComputedStyle(this.contentTarget)
    this.contentTargetPaddingTop = parseInt(contentStyle['padding-top'], 10)
    this.contentTargetPaddingBottom = parseInt(contentStyle['padding-bottom'], 10)
    this.contentTarget.style.pointerEvents = 'none'
    this.contentTarget.style.overflowY = 'hidden'
    this.contentTarget.style.paddingTop = '0'
    this.contentTarget.style.paddingBottom = '0'

    this.contentTarget.style.height = '0'
    this.contentTarget.style.display = 'block'
    this.contentTarget.style.transition = 'height 300ms ease-in-out, padding 300ms ease-in-out'
  }
  toggleHandler() {
    let newHeight = 0
    let newPaddingTop = 0
    let newPaddingBottom = 0
    let pointerEvents = 'none'
    this.element.classList.toggle('active')

    if (this.element.classList.contains('active')) {
      newHeight = Array.from(this.contentTarget.children).reduce((total, elem) => {
        const style = window.getComputedStyle(elem)
        const height = ['top', 'bottom']
          .map(function (side) {
            return parseInt(style['margin-' + side], 10)
          })
          .reduce(function (t, side) {
            return t + side
          }, elem.getBoundingClientRect().height)

        return (total += height)
      }, 0)

      newPaddingTop = this.contentTargetPaddingTop
      newPaddingBottom = this.contentTargetPaddingBottom
      pointerEvents = 'auto'
      newHeight += this.contentTargetPaddingTop
      newHeight += this.contentTargetPaddingBottom
    }
    this.contentTarget.style.pointerEvents = pointerEvents
    this.contentTarget.style.height = `${newHeight}px`
    this.contentTarget.style.paddingTop = `${newPaddingTop}px`
    this.contentTarget.style.paddingBottom = `${newPaddingBottom}px`
  }
}
